import { AbstractControl, ValidationErrors } from "@angular/forms"
import { isAfter } from "date-fns"

export const MaxDateValidator = (maxDate: Date) => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value instanceof Date) {
      if (isAfter(control.value, maxDate)) {
        return {
          maxDate: true
        }
      }
    }
    return null
  }
}
